// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__eqnrn","tabsList":"Tabs_tabsList__LZ3TE","tabContent":"Tabs_tabContent__XTfa0","additionalLine":"Tabs_additionalLine__gqhWl"};